import { Box } from '@mui/material';
import { Navigate } from 'react-router-dom';
import { RouteMap } from '@/routes/Routes';
import { useAuthStore } from '@/stores/authStore';
import { hasBetaProductName } from '@/utils/subscriptionHelpers';
import { useCurrentPlanFeatures } from '@/hooks/useCurrentPlanFeatures';
import SmartTags from './components/SmartTags';

const SmartTagsPage = () => {
  const { userData } = useAuthStore();
  const { betaFeatures, isLoading: isPlanLoading } = useCurrentPlanFeatures();
  if (!hasBetaProductName(userData) && !betaFeatures.smartTags && !isPlanLoading) {
    return <Navigate to={RouteMap.HOME} replace />;
  }

  return (
    <Box px={{ xs: '16px', sm: '32px' }} py="24px">
      <SmartTags />
    </Box>
  );
};

export default SmartTagsPage;
